import EventBus, { EVENTS } from '../eventBus';
import type { PleaseWaitDialogRequest } from './pleaseWaitDialogRequest';

export function showPleaseWaitDialog(message: string) {
  const req: PleaseWaitDialogRequest = {
    ongoingMessage: message
  };
  EventBus.emit(EVENTS.SHOW_DIALOG, {
    type: 'pleaseWait',
    req,
  });
}


export function hidePleaseWaitDialog() {
  EventBus.emit(EVENTS.HIDE_PLEASE_WAIT_DIALOG);
}
